import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertComponent } from '../../components/alert/alert.component';

@Injectable({
  providedIn: 'root',
})
export class OpenSnackbarService {
  constructor(private _snackBar: MatSnackBar) {}

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'success':
        classSnack = 'snackbar-success';
        break;
      case 'warning':
        classSnack = 'snackbar-warning';
        break;
      case 'error':
        classSnack = 'snackbar-error';
        break;
      default:
        classSnack = 'snackbar-default'; // Adiciona uma classe padrão para evitar string vazia
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
